module.exports = __webpack_public_path__ + "img/ring_r_o_1_1@2x.586076a8.png";